import { inject, Injectable } from '@angular/core';
import { AvaGetRequest } from '@dave/types';
import { AvaAddRequest, AvaDeleteRequest, AvaEditRequest } from '@dave/types/dist/proto/ava/ava';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AvaEntity } from '../../dave-data-module/entities/ava.entity';
import { AppGatewayService } from '../../dave-data-module/services/app-gateway.service';
import { State } from '../../dave-data-module/State';
import { getAvaById } from '../../dave-data-module/State/selectors/ava.selector';

@Injectable({
    providedIn: 'root',
})
export class AvaDataService {
    private store = inject(Store<State>);
    private api = inject(AppGatewayService);

    constructor() {}

    getAvaDetails$(id: number): Observable<AvaEntity> {
        // ggf fehlende sachen nachladen
        console.log('getAvaDetails', id);
        return this.store.select(getAvaById({ id: id }));
    }

    get$(payload: AvaGetRequest): Observable<AvaEntity[]> {
        return this.api.Request$({ AvaAvaGet: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return response.AvaAvaGet.Avas.map(AvaEntity.fromBackend);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }

    add$(payload: AvaAddRequest) {
        return this.api.Request$({ AvaAvaAdd: payload }).pipe(
            map((response) => {
                if (Object.keys(response?.Errors || {}).length === 0) {
                    return AvaEntity.fromBackend(response.AvaAvaAdd.Ava);
                } else {
                    throw response.Errors;
                }
            }),
        );
    }

    delete$(payload: AvaDeleteRequest) {
        return this.api.Request$({ AvaAvaDelete: payload }).pipe(
            map((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    return AvaEntity.fromBackend(res.AvaAvaDelete.Ava);
                } else {
                    throw res.Errors;
                }
            }),
        );
    }

    change$(payload: AvaEditRequest) {
        return this.api.Request$({ AvaAvaEdit: payload }).pipe(
            map((res) => {
                if (Object.keys(res?.Errors || {}).length === 0) {
                    return AvaEntity.fromBackend(res.AvaAvaEdit.Ava);
                } else {
                    throw res.Errors;
                }
            }),
        );
    }
}
